export function yieldToPaint() {
  return new Promise(resolve => setTimeout(resolve, 0))
}

export async function countWhere(list, predicate, isCancelled, chunkSize = 1000) {
  const items = list || []
  let count = 0
  for (let i = 0; i < items.length; i += chunkSize) {
    if (isCancelled()) return null
    const end = Math.min(i + chunkSize, items.length)
    for (let j = i; j < end; j++) {
      if (predicate(items[j])) count++
    }
    await yieldToPaint()
  }
  if (isCancelled()) return null
  return count
}

export async function mapTaskDepartmentIds(tasks, isCancelled, chunkSize = 1000) {
  const map = new Map()
  const items = tasks || []
  for (let i = 0; i < items.length; i += chunkSize) {
    if (isCancelled()) return null
    const end = Math.min(i + chunkSize, items.length)
    for (let j = i; j < end; j++) {
      const task = items[j]
      if (task) map.set(task.ID, task.DepartmentID)
    }
    await yieldToPaint()
  }
  if (isCancelled()) return null
  return map
}

export function workLogNeedsCount(item, level, departmentId, taskDepartmentById) {
  if (level > 100) return item.Status == "獎金簽核中"
  if (level == 10) {
    const departmentID = item.Task && item.Task.ID
      ? item.Task.DepartmentID
      : taskDepartmentById && taskDepartmentById.get(item.TaskID)
    return departmentID == departmentId && (
      item.Status == "主管確認中" ||
      item.Status == "獎金退回" ||
      item.Status == "審核預排中"
    )
  }
  return item.Status == ""
}

export function todoNeedsCount(item) {
  return !item.DoneAt
}
